/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpinWheelResponseWinningOutcome } from './SpinWheelResponseWinningOutcome';
import {
    SpinWheelResponseWinningOutcomeFromJSON,
    SpinWheelResponseWinningOutcomeFromJSONTyped,
    SpinWheelResponseWinningOutcomeToJSON,
    SpinWheelResponseWinningOutcomeToJSONTyped,
} from './SpinWheelResponseWinningOutcome';
import type { SpinWheelResponseWheelConfig } from './SpinWheelResponseWheelConfig';
import {
    SpinWheelResponseWheelConfigFromJSON,
    SpinWheelResponseWheelConfigFromJSONTyped,
    SpinWheelResponseWheelConfigToJSON,
    SpinWheelResponseWheelConfigToJSONTyped,
} from './SpinWheelResponseWheelConfig';

/**
 * 
 * @export
 * @interface SpinWheelResponse
 */
export interface SpinWheelResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SpinWheelResponse
     */
    success: boolean;
    /**
     * 
     * @type {SpinWheelResponseWheelConfig}
     * @memberof SpinWheelResponse
     */
    wheelConfig: SpinWheelResponseWheelConfig;
    /**
     * 
     * @type {SpinWheelResponseWinningOutcome}
     * @memberof SpinWheelResponse
     */
    winningOutcome: SpinWheelResponseWinningOutcome;
    /**
     * Whether rewards were successfully distributed
     * @type {boolean}
     * @memberof SpinWheelResponse
     */
    rewardsGranted: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpinWheelResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the SpinWheelResponse interface.
 */
export function instanceOfSpinWheelResponse(value: object): value is SpinWheelResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('wheelConfig' in value) || value['wheelConfig'] === undefined) return false;
    if (!('winningOutcome' in value) || value['winningOutcome'] === undefined) return false;
    if (!('rewardsGranted' in value) || value['rewardsGranted'] === undefined) return false;
    return true;
}

export function SpinWheelResponseFromJSON(json: any): SpinWheelResponse {
    return SpinWheelResponseFromJSONTyped(json, false);
}

export function SpinWheelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinWheelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'wheelConfig': SpinWheelResponseWheelConfigFromJSON(json['wheelConfig']),
        'winningOutcome': SpinWheelResponseWinningOutcomeFromJSON(json['winningOutcome']),
        'rewardsGranted': json['rewardsGranted'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function SpinWheelResponseToJSON(json: any): SpinWheelResponse {
    return SpinWheelResponseToJSONTyped(json, false);
}

export function SpinWheelResponseToJSONTyped(value?: SpinWheelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'wheelConfig': SpinWheelResponseWheelConfigToJSON(value['wheelConfig']),
        'winningOutcome': SpinWheelResponseWinningOutcomeToJSON(value['winningOutcome']),
        'rewardsGranted': value['rewardsGranted'],
        'message': value['message'],
    };
}

